<div class="content-header">
    <h2>Reimpresión de acuses</h2>
</div>
<form [formGroup]="formulario" (ngSubmit)="buscar()" (keydown.enter)="$event.preventDefault()">
    <div class="reprint-filters-container">

        <div class="filter-group-box type-filter-group">
            <label for="tipo-acuse">Tipo de Acuse:</label>
            <select id="tipo-acuse" class="form-select" formControlName="tipo">
                <option [value]="1">Promociones</option>
                <option [value]="2">Demandas</option>
            </select>
        </div>

        <div class="filter-group-box date-filter-group">
            <label for="fechaInicio">Buscar por fecha</label>
            <div class="date-inputs">
                <input type="date" class="form-control date-input eligeFecha" id="fechaInicio"
                    formControlName="fechaInicio" />
                <input type="date" class="form-control date-input eligeFecha" id="fechaFin"
                    formControlName="fechaFin" />
                <button class="btn-search">
                    Buscar
                </button>
            </div>
        </div>

        <!--    <div class="filter-group-box folio-filter-group">
            <label>Buscar por folio:</label>
            <div class="folio-input">
                <span class="search-icon"><i class="fas fa-search"></i></span>
                <input type="text" placeholder="Folio" formControlName="folio" class="form-control me-1">
                <button class="btn-search">
                    Buscar
                </button>
            </div>
        </div> -->

        <div class="filter-group-box date-filter-group">
            <label for="filtroGeneral">Filtro general:</label>
            <div class="folio-input">
                <span class="search-icon"><i class="fas fa-search"></i></span>
                <input type="text" placeholder="Búsqueda general" formControlName="filtroGeneral"
                    (input)="onFilterInputChange()" class="form-control me-1" />
            </div>
        </div>
        <oaj-exportar-excel [data]="(datosFilter | async) ?? []" [columns]="columnasReporte"
            [fileName]="+tipoAcuseSeleccionado === 1 ? 'Reporte Reimpresión de Acuses de Promociones.xlsx' : 'Reporte Reimpresión de Acuses de Demandas.xlsx' "
            [subtitle]=" 'Periodo Consultado: ' +  periodoFechaInicio  + ' - ' + periodoFechaFin "
            [supertitle]="nombreAutoridad"></oaj-exportar-excel>

    </div>
</form>
<oaj-alert-itx></oaj-alert-itx>
<div class="table-container tablaReimpresion">
    <table>
        <thead>
            <tr>
                @if (+tipoAcuseSeleccionado === 1){
                <th>Órgano Jurisdiccional</th>
                }
                @else {
                <th>OCC / Órgano jurisdiccional </th>
                }
                <!-- <th>Órgano Jurisdiccional</th> -->
                @if (+tipoAcuseSeleccionado === 1){
                <th>Número de Expediente</th>
                <th>Tipo Asunto</th>
                }
                <th>Origen</th>
                <th>Fecha y Hora de Recepción</th>
                <th>Acuse</th>
                <th>Archivos</th>
            </tr>
        </thead>
        <tbody>
            @for (item of (datosFilter | async); track item.idFolioRespuesta) {
            <tr>
                <td>{{item.organo}}</td>
                @if(+tipoAcuseSeleccionado === 1){
                <td>{{item.numExpediente}}</td>
                <td>{{item.tipoAsunto}}</td>
                }
                @if(+tipoAcuseSeleccionado === 1 ){
                <td>Promociones</td>
                }
                @else {
                <td>Demandas</td>
                }
                <td>{{item.fechaRecepcion | date:'dd/MM/yyyy HH:mm'}}</td>
                <td class="icon-cell">
                    <button type="button" (click)="getAcuse(item.idFolioRespuesta)" class="icon-button">
                        <i class="fas fa-file-invoice"></i>
                    </button>
                </td>
                <td class="icon-cell">
                    <button type="button" (click)="abrirModalDocumento(item.idFolioRespuesta)" class="icon-button">
                        <i class="fas fa-file-alt"></i>
                    </button>
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>


<ng-template #modalArchivos let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Archivos</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <div class="col-12 col-sm-auto">
            <div class="center">
                <oaj-loader-itx [loading]="archivosModalLoading" [sMensaje]="sMensajeLoad"
                    [failed]="archivosModalFailed" [sMensajeError]="archivosModalError">
                </oaj-loader-itx>
            </div>
            @if(!archivosModalLoading){
            <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="false"
                [verPrevisualizar]="true" [OcultaSystemName]="true">
            </oaj-lista-archivos-itx>
            }
        </div>
    </div>
</ng-template>